var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9815 6.13881C15.2908 5.82947 15.2908 5.32794 14.9815 5.0186C14.6721 4.70926 14.1706 4.70926 13.8613 5.0186L9.99992 8.87996L6.13856 5.0186C5.82923 4.70926 5.32769 4.70926 5.01836 5.0186C4.70902 5.32794 4.70902 5.82947 5.01836 6.13881L8.87971 10.0002L5.01836 13.8615C4.70902 14.1709 4.70902 14.6724 5.01836 14.9817C5.32769 15.2911 5.82923 15.2911 6.13856 14.9817L9.99992 11.1204L13.8613 14.9817C14.1706 15.2911 14.6721 15.2911 14.9815 14.9817C15.2908 14.6724 15.2908 14.1709 14.9815 13.8615L11.1201 10.0002L14.9815 6.13881Z",
    fill: "#FA4A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.4f93095f.svg";
export { ForwardRef as ReactComponent };